// `settings.changed` (spec/09-realtime-protocol.md §6.3).
//
// The one realtime message the outbox dispatcher publishes today. A setting is written to
// `setting_values` and an `org.setting.changed` row is written to the outbox in the same
// transaction; the worker invalidates the venue's resolved-settings cache in Valkey and publishes
// this frame on `venue:{id}:floor`, so a console that is looking at a settings screen refetches
// within a second rather than showing a value that is no longer true (spec/03 §7.3, §8, §9).
//
// It carries the keys and not the values. Who may see a setting is a permission question the
// gateway cannot answer per key, and a venue channel is read by every console in the venue, so the
// frame says what changed and the client asks for what it is allowed to see.
import { z } from "../zod.js";
import { SETTING_SCOPES } from "../settings/define-setting.js";
import { realtimeMessage } from "./envelope.js";
export const SettingsChangedPayloadSchema = z
    .object({
    /** The setting keys whose resolved value may have changed. Never the values. */
    keys: z.array(z.string().min(1)).min(1),
    /** The scope the change was made at — a platform change reaches every venue below it. */
    scopeType: z.enum(SETTING_SCOPES),
})
    .openapi('SettingsChangedPayload', {
    description: 'Which setting keys changed, and at which scope. The console refetches.',
});
/** `evt` on `venue:{id}:floor`. */
export const SETTINGS_CHANGED = 'settings.changed';
export const SettingsChangedMessage = realtimeMessage('evt', SETTINGS_CHANGED, SettingsChangedPayloadSchema);
//# sourceMappingURL=settings.js.map